const defaultState = {
    initialLoading: true,
    loading: false,
    error: false,
    totals: 0,
    page: 0,
    pageCount: 10,
    isActiveSearch: false,
    data: [],
    tag: {
        loading: true,
        error: null,
        data: {
            id: null,
            name: null,
        },
        actions: {
            save: {
                id: null,
                loading: false,
                success: false,
                error: null,
            }
        }
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'TAGS_FETCH_TAGS_START':
            return Object.assign({}, state, {
                initialLoading: state.initialLoading || state.error ? true : false,
                loading: true,
                error: false,
                isActiveSearch: action.payload.isActiveSearch,
            })

        case 'TAGS_FETCH_TAGS_SUCCESS':
            return Object.assign({}, state, {
                initialLoading: false,
                loading: false,
                data: [].concat(action.payload.tags),
                totals: action.payload.totals,
                pageCount: action.payload.pageCount,
                page: action.payload.pageCount * (action.payload.page) >= action.payload.totals ? action.payload.page - 1 : action.payload.page
            })

        case 'TAGS_FETCH_TAGS_FAIL':
            return Object.assign({}, state, {
                initialLoading: false,
                loading: false,
                error: true,
            })

        case 'TAGS_FETCH_TAG_START':
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    loading: true,
                })
            })

        case 'TAGS_FETCH_TAG_SUCCESS':
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    loading: false,
                    data: {
                        id: action.payload.tag.id,
                        name: action.payload.tag.nombre,
                    }
                })
            })

        case 'TAGS_FETCH_TAG_FAIL':
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    loading: false,
                    error: true,
                })
            })

        case 'TAGS_SAVE_TAG_START': {
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    actions: Object.assign({}, state.tag.actions, {
                        save: {
                            id: action.payload && action.payload.patch && action.payload.id ? action.payload.id : null,
                            loading: true,
                            success: false,
                            error: null,
                        }
                    })
                })
            })
        }

        case 'TAGS_SAVE_TAG_SUCCESS': {
            const data = action.payload && action.payload.patch && action.payload.id ? state.data.map((item) => {
                return item.id !== action.payload.id ? item : { ...item, ...action.payload.data }
            }) : null

            return Object.assign({}, state, {
                data: action.payload && action.payload.patch && action.payload.id ? [].concat(data) : state.data,
                tag: Object.assign({}, state.tag, {
                    actions: Object.assign({}, state.tag.actions, {
                        save: {
                            id: null,
                            loading: true,
                            success: true,
                            error: null,
                        }
                    })
                })
            })
        }

        case 'TAGS_SAVE_TAG_FAIL':
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    actions: Object.assign({}, state.tag.actions, {
                        save: {
                            id: null,
                            loading: false,
                            success: false,
                            error: true,
                        }
                    })
                })
            })

        case 'TAGS_SAVE_TAG_RESET':
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    actions: Object.assign({}, state.tag.actions, {
                        save: defaultState.tag.actions.save
                    })
                })
            })

        case 'TAGS_FORM_PROPERTY_VALUE_SET':
            return Object.assign({}, state, {
                tag: Object.assign({}, state.tag, {
                    data: Object.assign({}, state.tag.data, {
                        [action.payload.property]: action.payload.value
                    })
                })
            })

        case 'TAGS_TAG_RESET':
            return Object.assign({}, state, {
                tag: Object.assign({}, defaultState.tag)
            })

        case 'TAGS_RESET':
            return  Object.assign({}, state, defaultState)
        default:
            return state;
    }
}
